import { POST,postFile } from "../../index";

export const selectRenew = (param) => POST("/v1/renew/selectRenew", param);
export const updateRenew = (param) => POST("/v1/renew/updateRenew", param);
export const deviceRenew = (param) => postFile("/v1/renew/deviceRenew", param);
export const deviceScrap = (param) => postFile("/v1/renew/deviceScrap", param);
